import React, { useState,useContext,useEffect } from 'react'
import {dataContext,toText,localestr} from '../utils.js'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import Menu from '../cmp/menu'
import icon from '../icons.svg'
//import MsgForm from '../cmp/msgForm.js'

let findDlg=false

function CatCitiesList({data=undefined,actions,choice=false}){
    const type='catCities'
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    const context=useContext(dataContext)
    const Data=context.data[type]
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const msg=context.msg
    const glStatus=context.status

    const [edit, setEdit2] = useState(false)
    const setEdit=(d)=>{setGlData({edit:d});setEdit2(d)}

    const cols=[
        {caption:'icon',minWidth:'20',dataId:'catArts',sortable:false,typeVal:'submit',setFn:()=>{saveValue()}},
        {caption:'id',minWidth:'12',dataId:'id',sortable:true},
        {caption:localestr('Назва'),minWidth:'160',dataId:'name',sortable:true,typeVal:'text',setFn:(d)=>{setVal('name',d)}},
    ]

    const filterData=[ //+
        {caption:localestr('Назва'),dataId:'name',typeVal:'text'},
    ]

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            //const newItem={id:item.id,name:item.name,fio:item.fio,marked:item.marked}
            const newItem={...item}
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol(newItem)
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter})
        else{
            setWndData({...wndData,showFilter,filter,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const setVal=(name,data)=>{
        const list=wndData.list
        const sorting=wndData.sorting
        let currentCol=wndData.currentCol
        currentCol[name]=data
        setWndData({list,sorting,currentCol})
    }

    const newItem=()=>{
        if (edit) return
        let currentCol={id:''}
        const list=wndData.list.concat(currentCol)
        setWndData({...wndData,list,currentCol})
        setEdit(true)
    }
    
    const copyItem=()=>{
        if (edit) return
        if (typeof wndData.currentCol === 'object') {
            let currentCol={...wndData.currentCol}
            delete currentCol.id
            const list=wndData.list.concat(currentCol)
            setWndData({...wndData,list,currentCol})
            setEdit(true)
        }
    }

    const editItem=()=>{
        if (edit) return
        setEdit(true)
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }
            
    const removeItem=()=>{
        if (edit) return
        if (typeof wndData.currentCol === 'object') {
            let newData={status:'rem',key:type,data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='0'?'1':'0')}}
            saveData(newData,()=>{})
        }
    }

    const clrCatalog=(noQuestions)=>{
        if(noQuestions){
            let newData={status:'clr',key:type}
            saveData(newData,()=>{})
        }
        else msg(localestr('Буде видалено позначені елементи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrCatalog(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }

    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:type}},true)
        }
    }
        
    const setCol=(currentCol)=>{
        if (currentCol.id === wndData.currentCol?.id) return
        if ((getGlData()||{}).edit) {saveValue(()=>{setCol(currentCol)});return}
        setWndData({...wndData,currentCol})
        setGlData({needFocus:0})
    }
        
    const cancelEdit=()=>{
        sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        setEdit(false)
    }

    const saveValue=(act=null)=>{
        let errmsg=''
        if (typeof wndData.currentCol === 'object') {
            const name=(wndData.currentCol.name || '').substring(0,25)

            if (name===null || name==='') errmsg=localestr("Не заповнено назву")
            if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
            else{
                let newData
                let id=wndData.currentCol.id
                if (id===null || id==='' || id===undefined)  newData={status:'add',key:type,data:{name:name}}
                else newData={status:'mod',key:type,data:{id:id,name:name}}
                saveData(newData,()=>{})
                setEdit(false)
                if(act) setTimeout(act,500)        
            }
        }
    }

    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='F9') copyItem()
        else if(key==='Escape') cancelEdit()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
        //else console.log(key)
    }

    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if (typeof Data === 'undefined') getData(type)
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
    // eslint-disable-next-line 
    },[Data])

    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+

    const menuData=[
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        {name:localestr('Історія змін'),icon:'#b505',action:objHistory},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData(type)}},
    ]
    if(choice) menuData.splice(0,2)

    const findItem=(val)=>{
        const newData={...wndData,findText:val}
        findDlg=false
        newData.findArr=null
        if (val.length>1){
            const Arr=wndData.list.filter(el=>(el.id.indexOf(val)===0||(el.name||'').toLowerCase().indexOf(val.toLowerCase())!==-1||(el.barcode&&el.barcode.indexOf(val)===0))&&!parseInt(el.marked))
            if(Arr.length>10) Arr.splice(10)
            newData.findArr=Arr
            if(Arr.length) findDlg=true
            else{newData.findArr=null;findDlg=false}
        }
        setWndData(newData)
    }
    
    const findClick=(el)=>{
        const wndData_=actions.getWndData()
        const newData={...wndData_,currentCol:{...el},currentFld:{...el.parent},findText:'',findArr:null,currFind:-1}
        findDlg=false
        setWndData(newData)
        setGlData({needFocus:0})
    }
    
    const keyHandler=(e)=>{
        if(e.key==='ArrowUp'&&wndData.findArr) {
            if(wndData.currFind===undefined||wndData.currFind===-1) setWndData({...wndData,currFind:0})
            else if(wndData.currFind===0) setWndData({...wndData,currFind:wndData.findArr.length-1})
            else setWndData({...wndData,currFind:wndData.currFind-1})
        }
        else if(e.key==='ArrowDown'&&wndData.findArr) {
            if(wndData.currFind===undefined||wndData.findArr.length-1<=wndData.currFind) setWndData({...wndData,currFind:0})
            else setWndData({...wndData,currFind:wndData.currFind+1})
        }
        else if(e.key==='Enter'&&wndData.findArr&&wndData.currFind!==-1) {
            if(wndData.currFind===-1) findClick(wndData.findArr[0])
            else findClick(wndData.findArr[wndData.currFind])
        }
    }

    let findItems=null
    if(findDlg&&wndData.findArr){
        setTimeout(()=>findDlg=false,30000)
        const items=wndData.findArr.map((el,idx)=>{
            let stl={cursor:'pointer',fontSize:'small'}
            if(idx===wndData.currFind) stl.background='#9E91F7'
            return(
            <div key={idx} style={stl} onClick={()=>{findClick(el)}}>{el.id+' - '+el.name}</div>
        )})
        findItems=<div className='no-print' style={{right:'0px',top:'24px',width:'100%',position:'absolute',background:'#FFFFFF',zIndex:'100'}}>
            {items}
        </div>
    }
    
    return(
        <>
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)',width:'100%'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={newItem}
            onKeyUp={(e)=>{if(e.key === 'Enter') newItem()}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={()=>{editItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyItem} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={()=>{removeItem()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Фільтр')}  
            onClick={()=>{filter()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') filter()}}><img src={icon+'#filtBut'} alt={localestr('Фільтр')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div style={{position:'relative',padding:'3px'}}>
                <input id='search' type='text' value={wndData.findText||''} onChange={(e)=>{findItem(e.target.value)}}  onKeyUp={keyHandler}
                    onBlur={()=>{setTimeout(()=>{if(findDlg) setWndData({...wndData,findArr:null,currFind:undefined})},200)}} placeholder={localestr('пошук')} 
                    style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} />
                <img src={icon+'#b956'} alt='' style={{position:'absolute',right:'7px',top:'9px',width:'14px',height:'14px',opacity:0.5}}/>
                {findItems}
            </div>
            <div style={{flexGrow:'10'}}></div>

            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
            
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{...wndData.currentCol,edit}} sorting={sorting} filter={wndData.filter} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} tblPos={tblPos} needFocus={needFocus}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default CatCitiesList